import { DepositVueGB } from "./DepositVueGB";
import { ContractForecastData } from "fs-pb-vue2/data/contractForecastData";
import { ContractsApi } from "fs-pb-vue2/services/api/ContractsApi";
import IAlertService from "fs-pb-vue2/services/alert/IAlertService";
import { DiTokens } from "fs-pb-vue2/services/diTokens";
import { container } from "@/inversify.config";
import i18n from "@/i18n";

/** Модель представления счета */
export class ForecastModalVueGB extends DepositVueGB {
  
  /** Сервис вывода уведомлний */
  get alertService(): IAlertService {
    return container.get<IAlertService>(DiTokens.AlertService);
  }

  public forecastData: ContractForecastData | null = null;
  forecastLoading: boolean = false;

  get forecastMonthProfitText(): string {
    const monthName = this.getMonthName();
    return i18n.t('main.contracts.monthProfitText', { monthName }).toString();
  }

  async fetchForecastData(contractId: number): Promise<void> {
    this.forecastLoading = true;
    try {
      const data = await ContractsApi.getDepositForeCastData(contractId);
      this.forecastData = data;
    } catch (e: any) {
      this.alertService.error(e.message);
    }
    this.forecastLoading = false;
  }

  // Наименование текущего месяца
  getMonthName(): string {
    const date = new Date();
    return date.toLocaleString('default', { month: 'long' });
  }

  // Признак наличия прогноза на дату закрытия вклада
  get hasClosingForecast(): boolean {
    return this.contract.DateEnd != null && this.totalProfit != null;
  }

  // Строка с датой закрытия вклада
  get closeDateText(): string {
    if (!this.forecastData || !this.contract.Data.DateEnd) {
      return '';
    }

    const date = new Date(this.contract.Data.DateEnd);
    const today = new Date();

    if (date.getFullYear() === today.getFullYear()) {
      return i18n.t('main.contracts.closeDateTextThisYear', { date: date.toLocaleDateString('default', { day: 'numeric', month: 'long' }) }).toString();
    } else {
      return i18n.t('main.contracts.closeDateTextOtherYear', { date: date.toLocaleDateString('default', { day: 'numeric', month: 'long', year: 'numeric' }) }).toString();
    }
  }

  // Итоговая сумма дохода
  get totalProfit(): number | null {
    return this.forecastData ? this.forecastData.ProfitForecast : null;
  }

  // Итоговая сумма после окончания срока вклада
  get totalSum(): number | null {
    return this.contract.Data.Rest + this.totalProfit;
  }
}
